import { Product, useJurisdictionStore } from './use-jurisdiction';

export const isSocialWalletProduct = (product: Product) => product === Product.Sweeps || product === Product.Casino;

export const useHasSocialWallet = () => useJurisdictionStore(state => isSocialWalletProduct(state.product));
